// import "./App.css";
// import LandingPage from "./components/LandingPage/LandingPage";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import { Home } from "lucide-react";
// import Course from "./components/Course/Course";
// import Module from "./components/Module/Module";
// import Chapter from "./components/Chapter/Chapter";
// import ModuleList from "./components/Module/ModuleList";
// import { Toaster } from "react-hot-toast";
// import Navbar from "./components/Navbar";
// import Login from "./components/Auth/Login";

// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <div className="pb-20">
//         <Toaster position="bottom-center" reverseOrder={false} />
//         <Routes>
//           <Route path="/" element={<LandingPage />} />
//           <Route path="/home" element={<Home />} />
//           {/* <Route path="/" element={<LandingPage />} /> */}
//           <Route path="/course" element={<Course />} />
//           <Route path="/module" element={<Module />} />
//           <Route path="/chapter/:moduleId" element={<Chapter />} />
//           <Route path="/module-list/:courseId" element={<ModuleList />} />
//           <Route path="/login" element={<Login />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./components/LandingPage/LandingPage";
import AccessDenied from "./components/Auth/AccessDenied";
import Admin from "./components/AuditLogs/Admin";
import UserProfile from "./components/Auth/UserProfile";
import OAuth2RedirectHandler from "./components/Auth/OAuth2RedirectHandler";
import { Toaster } from "react-hot-toast";
import NotFound from "./components/NotFound";

import Home from "./components/Home/Home";
import Footer from "./components/Footer/Footer";
import Course from "./components/Course/Course";
import Module from "./components/Module/Module";
import Chapter from "./components/Chapter/Chapter";
import EditChapterInfo from "./components/Chapter/EditChapterInfo";
import ModuleList from "./components/Module/ModuleList";
import AddNew from "./components/Chapter/AddNew";
import ManageCourses from "./components/Course/ManageCourse";
import CourseNestedDetail from "./components/Course/CourseNestedDetail";
import BrowseCourses from "./components/Course/BrowseCourses";
import CourseCompleteDetail from "./components/Course/CourseCompleteDetail";
import CourseDetail from "./components/Course/CourseDetail";
import CourseCheckout from "./components/Course/CourseCheckout";
import Cart from "./components/Cart/Cart";
import Quiz from "./components/Quiz/Quiz";
import QuizListWithAnswers from "./components/Quiz/QuizListWithAnswers";
import AddArticle from "./components/Article/AddArticle";
import PlayQuiz from "./components/Quiz/PlayQuiz";
import ShowArticle from "./components/Article/ShowArticle";
import ManageMyCourses from "./components/Course/ManageMyCourses";
import UpdateCourse from "./components/Course/UpdateCourse";
import OrderDetail from "./components/Order/OrderDetail";
import InstructorRegistration from "./components/Instructor/InstructorRegistration";
import LearnerRegistration from "./components/Learner/LearnerRegistration";
import InstructorDetail from "./components/Instructor/InstructorDetail";
import MyProfile from "./components/Profile/MyProfile";
import EditProfile from "./components/Profile/EditProfile";
import MyLearning from "./components/Course/MyLearning";
import MyStudents from "./components/Instructor/MyStudents";
import MyEnrolledCourses from "./components/Learner/MyEnrolledCourses";
import InstructorWithCourses from "./components/Instructor/InstructorWithCourses";
import PrivacyPolicy from "./components/Support/PrivacyPolicy";
import Terms from "./components/Support/Terms";
import AboutUs from "./components/Support/AboutUs";
import Contact from "./components/Support/Contact";
import { Help } from "@mui/icons-material";
import HelpCenter from "./components/Support/HelpCenter";
import FAQ from "./components/Support/FAQ";
import RefundAndCancellation from "./components/Support/RefundAndCancellation";
import InstructorList from "./components/Instructor/InstructorList";
import BasicProfile from "./components/Profile/BasicProfile";
import Register from "./components/Auth/Register";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";

const App = () => {
  return (
    <Router>
      <Navbar />
      <div>
        <Toaster position="bottom-center" reverseOrder={false} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="/upload-course" element={<Course />} />
          <Route path="/module" element={<Module />} />
          <Route path="/chapter/:moduleId" element={<Chapter />} />
          <Route path="/edit-chapter-info/:chapterId" element={<EditChapterInfo />} />
          <Route path="/module-list/:courseId" element={<ModuleList />} />
          <Route path="/course-detail/:courseId/:slug" element={<CourseDetail />} />
          <Route path="/add-new/:moduleId" element={<AddNew />} />
          <Route path="/admin/manage-courses" element={<ManageCourses />} />
          <Route path="/add-quiz/:chapterId" element={<Quiz />} />
          <Route path="/add-article/:chapterId" element={<AddArticle />} />
          <Route path="/show-article/:chapterId" element={<ShowArticle />} />
          <Route path="/manage-my-courses" element={<ManageMyCourses />} />
          <Route path="/update-course/:courseId" element={<UpdateCourse />} />
          <Route path="/order-detail/:orderId" element={<OrderDetail />} />
          <Route path="/profile-detail" element={<MyProfile />} />
          <Route path="/profile-edit" element={<EditProfile />} />
          <Route path="/my-learning" element={<MyLearning />} />
          <Route path="/my-students" element={<MyStudents />} />
          <Route path="/learner/my-courses" element={<MyEnrolledCourses />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/refunds" element={<RefundAndCancellation />} />
          <Route path="/instructors" element={<InstructorList />} />
          <Route path="/basic-profile-setup" element={<BasicProfile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/instructors/:instructorId/:slug"
            element={
              <ProtectedRoute>
                <InstructorWithCourses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/instructors/:instructorId"
            element={<InstructorDetail />}
          />
          <Route
            path="/quiz-summary/:chapterId"
            element={<QuizListWithAnswers />}
          />
          <Route
            path="/course-nested-detail/:courseId"
            element={<CourseNestedDetail />}
          />
          <Route
            path="/browse-courses"
            element={
              <ProtectedRoute>
                <BrowseCourses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/course-complete-detail/:courseId"
            element={<CourseCompleteDetail />}
          />
          <Route
            path="/course-checkout/:courseId"
            element={<CourseCheckout />}
          />
          <Route
            path="/show-my-cart"
            element={
              <ProtectedRoute>
                <Cart />
              </ProtectedRoute>
            }
          />
          <Route path="/play-quiz/:chapterId" element={<PlayQuiz />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute adminPage={true}>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
          <Route path="/home" element={<Home />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
